import { DepositAmount } from '../../../../investment/components/transfer/DepositAmount';

export default function DepositAmountScreen() {
    return <DepositAmount />;
}
